import CardDashboardTemplate from "@/pages/DashboardPage/components/templates/CardDashboardTemplate"

export const FallbackCardDashboard = (props: {
  title: string
  subTitle?: string
}) => (
  <CardDashboardTemplate loading {...props}>
    {null}
  </CardDashboardTemplate>
)
